'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { PortfolioPanelHeader } from '@/components/portfolio/shared/portfolio-panel-header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/app-tabs';
import { Panel, PanelContent } from '@/components/ui/panel';
import { SelectField } from '@/components/ui/select-field';
import { useFeatureGate } from '@/hooks/use-feature-gate';
import { CreatedMarkets, CreatedProposals } from './created-content-list';
export function CreatedPanel(t0) {
  const $ = _c(4);
  const {
    userId,
    handle,
    displayName
  } = t0;
  const enabled = useFeatureGate("creator_and_platform_markets");
  if (enabled !== true) {
    return null;
  }
  let t1;
  if ($[0] !== displayName || $[1] !== handle || $[2] !== userId) {
    t1 = <CreatedPanelContent userId={userId} handle={handle} displayName={displayName} />;
    $[0] = displayName;
    $[1] = handle;
    $[2] = userId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
function CreatedPanelContent(t0) {
  const $ = _c(65);
  const {
    userId,
    handle,
    displayName
  } = t0;
  const t = useTranslations("profile.created");
  const [group, setGroup] = useState("markets");
  const [status, setStatus] = useState("trading,resolved,graduated");
  const [sortOrder, setSortOrder] = useState("desc");
  let t1;
  if ($[0] !== t) {
    t1 = t("title");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handle) {
    t2 = handle ? <span className="text-caption text-foreground-tertiary">@{handle}</span> : null;
    $[2] = handle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <PortfolioPanelHeader title={t1} action={t2} />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("title");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("markets");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <TabsTrigger value="markets">{t5}</TabsTrigger>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("proposals");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <TabsTrigger value="proposals">{t7}</TabsTrigger>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t9 = <TabsList variant="segmented" className="w-auto" aria-label={t4}>{t6}{t8}</TabsList>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== group || $[22] !== status || $[23] !== t) {
    t10 = group === "markets" ? <SelectField size="sm" aria-label={t("statusLabel")} value={status} onValueChange={setStatus} items={[{
      value: "trading",
      label: t("open")
    }, {
      value: "resolved,graduated",
      label: t("resolved")
    }, {
      value: "trading,resolved,graduated",
      label: t("allMarkets")
    }]} /> : null;
    $[21] = group;
    $[22] = status;
    $[23] = t;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("sortLabel");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = value => {
      if (value === "asc" || value === "desc") {
        setSortOrder(value);
      }
    };
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t("newest");
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t13) {
    t14 = {
      value: "desc",
      label: t13
    };
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t("oldest");
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15) {
    t16 = {
      value: "asc",
      label: t15
    };
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t14 || $[37] !== t16) {
    t17 = [t14, t16];
    $[36] = t14;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== sortOrder || $[40] !== t11 || $[41] !== t17) {
    t18 = <SelectField size="sm" aria-label={t11} value={sortOrder} onValueChange={t12} items={t17} />;
    $[39] = sortOrder;
    $[40] = t11;
    $[41] = t17;
    $[42] = t18;
  } else {
    t18 = $[42];
  }
  let t19;
  if ($[43] !== t10 || $[44] !== t18) {
    t19 = <div className="flex items-center gap-2">{t10}{t18}</div>;
    $[43] = t10;
    $[44] = t18;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  if ($[46] !== t19 || $[47] !== t9) {
    t20 = <div className="flex flex-wrap items-center justify-between gap-3">{t9}{t19}</div>;
    $[46] = t19;
    $[47] = t9;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  const t21 = displayName ?? handle ?? "";
  let t22;
  if ($[49] !== sortOrder || $[50] !== status || $[51] !== t21 || $[52] !== userId) {
    t22 = <TabsContent value="markets"><CreatedMarkets userId={userId} status={status} sortOrder={sortOrder} creatorName={t21} /></TabsContent>;
    $[49] = sortOrder;
    $[50] = status;
    $[51] = t21;
    $[52] = userId;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== sortOrder || $[55] !== userId) {
    t23 = <TabsContent value="proposals"><CreatedProposals userId={userId} sortOrder={sortOrder} /></TabsContent>;
    $[54] = sortOrder;
    $[55] = userId;
    $[56] = t23;
  } else {
    t23 = $[56];
  }
  let t24;
  if ($[57] !== group || $[58] !== t20 || $[59] !== t22 || $[60] !== t23) {
    t24 = <Tabs value={group} onValueChange={setGroup}>{t20}{t22}{t23}</Tabs>;
    $[57] = group;
    $[58] = t20;
    $[59] = t22;
    $[60] = t23;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== t24 || $[63] !== t3) {
    t25 = <Panel data-testid="portfolio-created"><PanelContent className="flex flex-col gap-4">{t3}{t24}</PanelContent></Panel>;
    $[62] = t24;
    $[63] = t3;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  return t25;
}